<template>
  <div>
    <div class="center verticalPadding marginTop">
      <strong class="titles">
        <template v-for="step in steps">
          <span
            :class="stepNum === step.index ? 'selectedDot' : 'unselectedDot'"
            :key="'tag-' + step.index"
          >
            {{ step.tag }}
          </span>
          <strong
            v-if="steps[steps.length - 1] !== step"
            :key="'>-' + step.index"
          >
            >
          </strong>
        </template>
      </strong>
    </div>
    <div class="marginLR">
      <Success
        v-if="
          (stepNum === 1 || stepNum === 2) &&
          this.success &&
          this.success.length > 0 &&
          this.currentDraft.pagado
        "
        :success="this.success"
      />
      <Errors
        v-if="
          (stepNum === 1 || stepNum === 2) &&
          this.errors &&
          this.errors.length > 0 &&
          !this.currentDraft.pagado
        "
        :errors="this.errors"
      />
      <DatosCliente
        ref="datosCliente"
        v-if="stepNum === 1"
        :paid="currentDraft.pagado"
        :clientData="currentDraft.datos.datosUsuario"
        @actOnOwnName="handleOnActOnOwnNameSelect"
      />
      <DatosDeudorOAcreedor
        ref="datosAcreedor"
        v-if="stepNum === 1"
        :entidades="entidadesAcreedor"
        :paid="currentDraft.pagado"
        :actOnOwnName="calculoActuoEnPropioNombre()"
        :creditorOrDebtorData="currentDraft.datos.datosAcreedor"
        :defaultLanguage="defaultLanguage"
        :isDebtor="false"
        @address:input="loadingCTIAddressNormalization = $event"
      />
      <DatosDeudorOAcreedor
        ref="datosDeudor"
        v-if="stepNum === 2"
        :entidades="entidadesDeudor"
        :paid="currentDraft.pagado"
        :creditorOrDebtorData="currentDraft.datos.datosDeudor"
        :defaultLanguage="defaultLanguage"
        :isDebtor="true"
        @address:input="loadingCTIAddressNormalization = $event"
      />
      <DatosDeuda
        ref="datosDeuda"
        :defaultLanguage="defaultLanguage"
        :debtorData="currentDraft.datos.datosDeudor"
        v-if="stepNum === 3"
        :paid="currentDraft.pagado"
      />
    </div>

    <div class="openTopWhitePanel marginLR">
      <div class="grid">
        <div class="col-3">
          <div>
            <Button
              @click.prevent="backward()"
              :label="
                stepNum === 1
                  ? this.$t('altaImpago.botones.inicio')
                  : this.$t('altaImpago.botones.atras')
              "
              class="bigBlueButton"
              icon="pi pi-angle-left"
              iconPos="left"
              :disabled="loadingCTIAddressNormalization"
            />
          </div>
        </div>

        <div class="col-3 col-offset-6">
          <div>
            <Button
              @click.prevent="forward()"
              :label="
                stepNum !== steps.length
                  ? this.$t('altaImpago.botones.siguiente')
                  : this.$t('altaImpago.botones.finalizar')
              "
              class="bigBlueButton rightAlign"
              icon="pi pi-angle-right"
              iconPos="right"
              :disabled="loadingCTIAddressNormalization"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="layout-content">
      <Toast />
    </div>
    <Dialog
      :header="$t('altaImpago.labels.anexarReclamacion')"
      position="top"
      :visible.sync="displayAnnexableModal"
      :modal="true"
      :contentStyle="{ overflow: 'visible' }"
      class="modal"
    >
      <p class="m-0">
        {{ $t("altaImpago.textos.anexarReclamacion") }}
      </p>
      <template #footer>
        <Button
          :label="$t('common.no')"
          icon="pi pi-times"
          @click="
            [
              (checkAnnexableClaim.anexable = false),
              (displayAnnexableModal = false),
              createClaim(),
            ]
          "
          class="cancelButton"
        />
        <Button
          :label="$t('common.yes')"
          icon="pi pi-check"
          @click="
            [
              (checkAnnexableClaim.anexable = true),
              (displayAnnexableModal = false),
              createClaim(),
            ]
          "
          autofocus
        />
      </template>
    </Dialog>

    <Dialog
      :header="$t('altaImpago.labels.aplicarBono')"
      position="top"
      :visible.sync="showConfirmacionBono"
      :modal="true"
      :contentStyle="{ overflow: 'visible' }"
      class="modal"
    >
      <p class="m-0">
        {{ $t("altaImpago.textos.aplicarBono") }}
      </p>
      <template #footer>
        <Button
          :label="$t('common.yes')"
          icon="pi pi-check"
          @click="
            [(showConfirmacionBono = false), (bonoConfirmado = true), forward()]
          "
          autofocus
        />
      </template>
    </Dialog>

    <Dialog
      :header="$t('altaImpago.labels.borradorEncontrado')"
      :modal="true"
      :visible.sync="displayDraftWarningModal"
      :contentStyle="{ overflow: 'visible' }"
      :style="{ width: '65vw' }"
      class="modal"
    >
      <p>{{ $t("altaImpago.textos.borradorEncontrado") }}</p>
      <template #footer>
        <Button
          @click.prevent="$router.push('/dashboard/my-operations/borradores')"
          :label="$t('altaImpago.botones.continualConBorrador')"
          class="button-primary"
        />
        <Button
          @click.prevent="displayDraftWarningModal = false"
          :label="$t('altaImpago.botones.crearNuevaReclamacion')"
          class="button-secondary"
          icon="pi pi-times"
          iconPos="left"
        />
      </template>
    </Dialog>
    <Dialog
      :header="$t('altaImpago.labels.avisoProcesoLegalDesfavorable')"
      :modal="true"
      :visible.sync="displayLegalProcessWarningModal"
      :contentStyle="{ overflow: 'visible' }"
      :style="{ width: '65vw' }"
      class="modal"
    >
      <p>{{ $t("altaImpago.textos.avisoProcesoLegalDesfavorable") }}</p>
    </Dialog>
  </div>
</template>


<script>
import DatosCliente from "@/components/portal-cliente/DatosCliente.vue";
import DatosDeudorOAcreedor from "@/components/portal-cliente/DatosDeudorOAcreedor.vue";
import DatosDeuda from "@/components/portal-cliente/DatosDeuda.vue";
import {
  QUERY_BORRADORES,
  QUERY_BORRADOR,
  MUTATION_CREATE_DRAFT,
  MUTATION_EDIT_DRAFT
} from "@/graphQLQueries/BorradoresQueries";
import {
  MUTATION_ALTA_RECLAMACION,
  QUERY_CHECK_RECLAMACION_ANEXABLE,
} from "@/graphQLQueries/ReclamacionQueries";
import { QUERY_BONO_APLICABLE } from "@/graphQLQueries/FacturaQueries";
import {
  MAKE_PAYMENT,
  UPDATE_TRANSACTION_STATUS,
} from "@/graphQLQueries/PaymentQueries";
import RoutesMixin from "@/utils/routes";
import StringsMixin from "@/utils/strings";
import {
  TIPOS_USUARIOS,
  PLATAFORMA,
  TIPOS_SERVICIO,
} from "@/resources/constants";
import MessagesMixin from "@/utils/messages";
import Success from "@/components/utilidades/Success.vue";
import Errors from "@/components/utilidades/Errors.vue";

const PROCESO_DESFAVORABLE = "siAccionLegalDesfavorable";

export default {
  name: "RegistrarImpago",
  components: {
    DatosCliente,
    DatosDeudorOAcreedor,
    DatosDeuda,
    Success,
    Errors,
  },
  mixins: [RoutesMixin, StringsMixin, MessagesMixin],
  data() {
    return {
      success: [],
      errors: [],
      entidadesAcreedor: [
        {
          tipo: "Particular",
          key: TIPOS_USUARIOS.USUARIO_TIPO_ACREEDOR_PARTICULAR,
          index: 1,
        },
        {
          tipo: "Autónomo",
          key: TIPOS_USUARIOS.USUARIO_TIPO_ACREEDOR_AUTONOMO,
          index: 2,
        },
        {
          tipo: "Persona jurídica u otro ente sin personalidad jurídica (Empresa, Instituto, ...)",
          key: TIPOS_USUARIOS.USUARIO_TIPO_ACREEDOR_ENTIDAD,
          index: 3,
        },
      ],
      entidadesDeudor: [
        {
          tipo: "Particular",
          key: TIPOS_USUARIOS.USUARIO_TIPO_DEUDOR_PARTICULAR,
          index: 1,
        },
        {
          tipo: "Autónomo",
          key: TIPOS_USUARIOS.USUARIO_TIPO_DEUDOR_AUTONOMO,
          index: 2,
        },
        {
          tipo: "Persona jurídica u otro ente sin personalidad jurídica (Empresa, Instituto, ...)",
          key: TIPOS_USUARIOS.USUARIO_TIPO_DEUDOR_ENTIDAD,
          index: 3,
        },
      ],
      claimTypes: [
        {
          code: "basic",
          internalValue: "ICIRED_BASICO",
        },
        {
          code: "burofax",
          internalValue: "ICIRED_BUROFAX",
        },
        {
          code: "notarial",
          internalValue: "ICIRED_NOTARIAL",
        },
      ],
      stepNum: 1,
      steps: [
        { tag: "1", index: 1 },
        { tag: "2", index: 2 },
        { tag: "3", index: 3 },
      ],
      titularTarjeta: {
        codigoPostal: "",
        direccion: "",
        email: "",
        localidad: "",
        nombreCompleto: "",
        provincia: "",
        telefono: "",
      },
      defaultLanguage: { key: "ES", language: "es" },
      actOnOwnName: false,
      checkAnnexableClaim: {
        anexable: null,
      },
      showConfirmacionBono: false,
      displayDraftWarningModal: false,
      bonoConfirmado: false,
      displayAnnexableModal: false,
      displayLegalProcessWarningModal: false,
      currentDraft: {
        pagado: false,
        codigoProducto: "",
        referenciaPago: "",
        id: 0,
        datos: {
          datosAcreedor: {
            apellidos: "",
            codigoPostal: "",
            direccion: "",
            email: "",
            idLegal: null,
            localidad: "",
            nombre: "",
            pais: "",
            provincia: "",
            razonSocial: "",
            sectorActividad: "",
            codigoActividad: "",
            telefono: "",
            tipoEntidad: "",
            tipoSociedad: "",
            tipoVia: "C",
          },
          datosDeudor: {
            apellidos: "",
            codigoPostal: "",
            direccion: "",
            email: "",
            idLegal: "",
            localidad: "",
            nombre: "",
            pais: "",
            provincia: "",
            razonSocial: "",
            sectorActividad: "",
            codigoActividad: "",
            telefono: "",
            tipoEntidad: "",
            tipoSociedad: "",
            tipoVia: "C",
          },
          datosDeuda: {
            demandaJudicial: "",
            iban: "",
            listaImpagos: [],
            observaciones: "",
            origenDeuda: "",
          },
          datosUsuario: {
            apellidos: "",
            nif: "",
            nombre: "",
            telefono: "",
            actuoEnPropioNombre: "",
          },
        },
      },
      loadingCTIAddressNormalization: false,
    };
  },
  methods: {
    calculoActuoEnPropioNombre() {
      return (
        this.actOnOwnName ||
        (this.currentDraft &&
          this.currentDraft.datos.datosUsuario.actuoEnPropioNombre === "true")
      );
    },
    backward() {
      if (this.stepNum === 1) {
        this.goToDashboardtView("claim-debt");
      } else if (this.stepNum === 2) {
        this.updateDireccionDeudor();
      }

      this.stepNum -= 1;
      this.goToEditDraftView(
        this.$route.params.claimType,
        this.getCurrentStepFromStepNum(),
        this.currentDraft.id
      );
      window.scrollTo(0, 0);
    },
    async forward() {
      this.errors = [];
      if (this.stepNum === 1) {
        this.updateDireccionAcreedor();
        if (!this.currentDraft.pagado) {
          this.$refs.datosCliente.validateForm();
          this.$refs.datosAcreedor.validateForm();
        }

        if (!this.hasCreditorFormErrors()) {
          if (this.currentDraft.id === 0) {
            await this.createDraft();
          } else {
            await this.editDraft();
          }
          this.checkBonoAplicables();
          this.stepNum += 1;

          this.goToEditDraftView(
            this.$route.params.claimType,
            this.getCurrentStepFromStepNum(),
            this.currentDraft.id
          );
          window.scrollTo(0, 0);
        }
      } else if (this.stepNum === 2) {
        this.updateDireccionDeudor();
        this.$refs.datosDeudor.validateForm();

        if (!this.hasDebtorFormErrors()) {
          if (!this.currentDraft.pagado) {
            await this.editDraft();
            if (
              this.success &&
              this.success.length > 0 &&
              !this.bonoConfirmado
            ) {
              this.showConfirmacionBono = true;
            } else {
              if (this.errors.length === 0) await this.makePayment();
            }
          } else {
            await this.editDraft();
            this.stepNum += 1;
            this.goToEditDraftView(
              this.$route.params.claimType,
              this.getCurrentStepFromStepNum(),
              this.currentDraft.id
            );
            window.scrollTo(0, 0);
          }
        }
      } else if (this.stepNum === 3) {
        if (this.$refs.datosDeuda.datosDeuda.demanda === PROCESO_DESFAVORABLE) {
          this.displayLegalProcessWarningModal = true;
        } else {
          this.$refs.datosDeuda.validateForm();
          if (!this.hasDebtFormErrors()) {
            this.checkReclamacionAnexable();
          } else {
            window.scrollTo(0, 0);
          }
        }
      }
    },
    async createDraft() {
      var draft = {
        apiTransactionId: "",
        codigoProducto: this.currentDraft.codigoProducto,
        pagado: false,
        plataforma: "icired",
        tipo: "reclamacion",
        datos: this.currentDraft.datos,
        uuidUsuario: this.$store.state.profile.uuid,
      };
      try {
        const response = await this.$apollo.mutate({
          mutation: MUTATION_CREATE_DRAFT,
          variables: {
            input: draft,
          },
        });

        setTimeout(() => {
          this.displayInfoToast(
            this.$t("miCuenta.labels.crearBorrador"),
            this.$t("miCuenta.textos.crearBorrador")
          );
        }, 1);
        this.currentDraft = response.data.altaBorrador;
      } catch (e) {
        throw Error(e);
      }
    },
    async editDraft() {
      var draft = {
        datos: this.currentDraft.datos,
        id: this.currentDraft.id,
        pagado: this.currentDraft.pagado,
        referenciaPago: this.currentDraft.referenciaPago,
      };

      try {
        await this.$apollo
          .mutate({
            mutation: MUTATION_EDIT_DRAFT,
            variables: {
              input: draft,
            },
          })
          .then(() => {
            setTimeout(() => {
              this.displayInfoToast(
                this.$t("altaImpago.labels.editarBorrador"),
                this.$t("altaImpago.textos.editarBorrador")
              );
            }, 2);
          })
          .catch((e) => {
            e.graphQLErrors.forEach((error) => {
              this.errors.push(
                this.$i18n.t("altaImpago.errores." + error.message)
              );
            });
          });
      } catch (e) {
        throw Error(e);
      }
    },
    createClaimInput() {
      return {
        acreedor: this.getUserData("datosAcreedor"),
        actuoEnPropioNombre:
          this.currentDraft.datos.datosUsuario.actuoEnPropioNombre,
        altaCamposRIJRequest: null,
        anexable: this.checkAnnexableClaim.anexable,
        apiTransactionId: this.currentDraft.apiTransactionId,
        avisos: true,
        deudor: this.getUserData("datosDeudor"),
        divisa: this.$refs.datosDeuda.datosDeuda.divisa,
        ibanAcreedor: this.$refs.datosDeuda.iban.replaceAll(" ", ""),
        idLegalCliente: this.$store.state.clienteIdLegal,
        idBorrador: this.currentDraft.id,
        token: this.currentDraft.token,
        impagos: this.$refs.datosDeuda.datosDeuda.impagos,
        lficherosAcreditacionDeuda: this.$refs.datosDeuda.files,
        observaciones: this.$refs.datosDeuda.datosDeuda.observaciones,
        origen: this.$refs.datosDeuda.datosDeuda.origen,
        producto: this.currentDraft.codigoProducto,
        tipoContrato: "PEQUENAS_CUENTAS",
        usuario: this.getUserData("datosUsuario"),
        viaJudicial: this.$refs.datosDeuda.demandaJudicial,
        viaJudicialFavorable: this.$refs.datosDeuda.demandaJudicialFavorable,
        fuente: "web",
      };
    },
    getUserData(userType) {
      return {
        apellidos: this.currentDraft.datos[userType].apellidos,
        cnae: this.currentDraft.datos[userType].codigoActividad,
        codigoPostal: this.currentDraft.datos[userType].codigoPostal,
        direccion: this.currentDraft.datos[userType].direccion,
        email: this.currentDraft.datos[userType].email,
        idLegal: this.currentDraft.datos[userType].idLegal,
        localidad: this.currentDraft.datos[userType].localidad,
        nombre: this.currentDraft.datos[userType].nombre,
        pais: this.currentDraft.datos[userType].pais,
        provincia: this.currentDraft.datos[userType].provincia,
        razonSocial: this.currentDraft.datos[userType].razonSocial,
        telefono: this.currentDraft.datos[userType].telefono,
        tipo: this.currentDraft.datos[userType].tipoEntidad,
        tipoDireccion: this.currentDraft.datos[userType].tipoVia,
        tipoSociedad: this.currentDraft.datos[userType].tipoSociedad,
        uuid:
          userType === "datosUsuario" ? this.$store.state.profile.uuid : null,
      };
    },
    checkReclamacionAnexable() {
      this.$apollo
        .query({
          query: QUERY_CHECK_RECLAMACION_ANEXABLE,
          variables: {
            idLegalCliente: this.currentDraft.datos.datosUsuario.nif,
            origen: this.$refs.datosDeuda.datosDeuda.origen,
            producto: this.currentDraft.codigoProducto,
            uuidDeudor: null,
            uuidAcreedor: null,
            idLegalAcreedor: this.currentDraft.datos.datosAcreedor.idLegal,
            idLegalDeudor: this.currentDraft.datos.datosDeudor.idLegal,
            uuidUsuario: this.$store.state.profile.uuid,
            tipoAcreedor: this.currentDraft.datos.datosAcreedor.tipoEntidad,
            tipoDeudor: this.currentDraft.datos.datosDeudor.tipoEntidad,
          },
          fetchPolicy: "no-cache",
        })
        .then((data) => {
          this.checkAnnexableClaim.anexable =
            data.data.checkReclamacionAnexable.anexable;
          if (this.checkAnnexableClaim.anexable) {
            this.displayAnnexableModal = true;
          } else {
            this.createClaim();
          }
        })
        .catch(() => {});
    },
    createClaim() {
      var claim = this.createClaimInput();

      this.$apollo
        .mutate({
          mutation: MUTATION_ALTA_RECLAMACION,
          variables: {
            input: claim,
          },
        })
        .then((data) => {
          this.goToClaimViewFromAltaReclamacion(
            data.data.altaReclamacion.token
          );
        })
        .catch((e) => {
          throw Error(e);
        });
    },
    hasDebtFormErrors() {
      if (typeof this.$refs.datosDeuda != "undefined" && this.stepNum === 3) {
        return this.$refs.datosDeuda.hasFormErrors();
      }
      return true;
    },
    hasDebtorFormErrors() {
      if (this.$refs.datosDeudor != undefined && this.stepNum === 2) {
        return this.$refs.datosDeudor.hasFormErrors();
      }
      return true;
    },
    hasCreditorFormErrors() {
      if (
        this.$refs.datosAcreedor != undefined &&
        this.$refs.datosCliente != undefined &&
        this.stepNum === 1
      ) {
        return (
          this.$refs.datosAcreedor.hasFormErrors() ||
          this.$refs.datosCliente.hasFormErrors()
        );
      }
      return true;
    },
    async makePayment() {
      const idBorrador = this.currentDraft.id;
      this.claimType = this.setProductCodeOrElseError();
      const urlReturn = `${window.location.origin}/drafts/${this.claimType}/debt/${idBorrador}`;

      try {
        const response = await this.$apollo
          .mutate({
            mutation: MAKE_PAYMENT,
            variables: {
              idBorrador,
              plataforma: PLATAFORMA,
              urlReturn,
            },
          })
          .catch((error) => {
            this.errors.push(
              this.$i18n.t(
                "altaImpago.errores." + error.graphQLErrors[0].message
              )
            );
          });
        if (response.data.makeWorldlineRedirectPayment.bono) {
          this.stepNum += 1;
          this.goToDebtView(this.$route.params.claimType, this.currentDraft.id);
          window.scrollTo(0, 0);
        } else {
          location.replace(
            response.data.makeWorldlineRedirectPayment.datos.url
          );
        }
      } catch (e) {
        throw Error(e);
      }
    },
    async searchDraftById(draftId) {
      try {
        const response = await this.$apollo.query({
          query: QUERY_BORRADOR,
          variables: {
            id: draftId,
          },
          fetchPolicy: "no-cache",
        });
        const draft = response.data.borrador;

        if (draft.referenciaPago && !draft.pagado) {
          const wlResponse = await this.$apollo.mutate({
            mutation: UPDATE_TRANSACTION_STATUS,
            variables: {
              operationId: draft.referenciaPago,
            },
          });

          draft.pagado =
            (
              wlResponse.data.updateTransactionStatus.datos || ""
            ).toUpperCase() === "SUCCESSFUL";
        }

        this.setCurrentDraftData(draft);
        this.checkBonoAplicables();
      } catch (e) {
        console.error(e);
        this.goTo403View();
      }
    },
    setCurrentDraftData(draft) {
      if (draft.datos.datosAcreedor) {
        this.$set(
          this.currentDraft.datos,
          "datosAcreedor",
          draft.datos.datosAcreedor
        );
      }
      if (draft.datos.datosDeudor) {
        this.$set(
          this.currentDraft.datos,
          "datosDeudor",
          draft.datos.datosDeudor
        );
      }
      if (draft.datos.datosDeuda) {
        this.$set(
          this.currentDraft.datos,
          "datosDeuda",
          draft.datos.datosDeuda
        );
      }
      if (draft.datos.datosUsuario) {
        this.$set(
          this.currentDraft.datos,
          "datosUsuario",
          draft.datos.datosUsuario
        );
      }
      this.$set(this.currentDraft, "referenciaPago", draft.referenciaPago);
      this.$set(this.currentDraft, "pagado", draft.pagado);
      this.$set(this.currentDraft, "id", draft.id);
      this.$set(this.currentDraft, "codigoProducto", draft.codigoProducto);
    },
    setProductCodeOrElseError() {
      const claimType = this.$route.params.claimType;

      if (
        claimType !== undefined &&
        this.currentDraft.id === 0 &&
        this.stepNum === 1
      ) {
        this.currentDraft.codigoProducto = claimType;
      }
      return claimType;
    },
    setCurrentStep() {
      const step = this.$route.params.step;
      if (step !== undefined) {
        switch (step) {
          case "creditor":
            this.stepNum = 1;
            break;
          case "debtor":
            this.stepNum = 2;
            break;
          case "debt":
            this.stepNum = 3;
            break;
          default:
            this.stepNum = 1;
        }
      }
    },
    checkBonoAplicables() {
      if (
        this.currentDraft.id &&
        this.currentDraft.id != 0 &&
        this.success.length === 0
      ) {
        this.$apollo
          .query({
            query: QUERY_BONO_APLICABLE,
            variables: {
              idBorrador: this.currentDraft.id,
            },
            fetchPolicy: "no-cache",
          })
          .then((data) => {
            this.success = [];
            if (data.data.bonoAplicable.encontrado) {
              this.success.push(
                this.$i18n.t("altaImpago.textos.bonoAplicado1") +
                  (data.data.bonoAplicable.numeroDeUsos -
                    data.data.bonoAplicable.contadorUsos) +
                  this.$i18n.t("altaImpago.textos.bonoAplicado2")
              );
            }
          })
          .catch((e) => {
            throw Error(e);
          });
      }
    },
    getCurrentStepFromStepNum() {
      switch (this.stepNum) {
        case 1:
          return "creditor";
        case 2:
          return "debtor";
        case 3:
          return "debt";
        default:
          return "creditor";
      }
    },
    displayInfoToast(summary, detail) {
      this.$toast.add({
        severity: "info",
        summary: summary,
        detail: detail,
        life: 3000,
      });
    },
    async searchCurrentDraft() {
      const draftId = this.$route.params.draftId;
      if (draftId != undefined) {
        await this.searchDraftById(draftId);
      }
      if (this.stepNum === 3 && !this.currentDraft.pagado) {
        this.backward();
      }
    },
    handleOnActOnOwnNameSelect(value) {
      this.actOnOwnName = value;
    },
    checkPreviousDrafts() {
      // Si se detectan borradores previos se lanza el aviso al usuario.
      this.$apollo
        .query({
          query: QUERY_BORRADORES,
          variables: {
            criteria: {
              filter: [
                `usuario.uuid~uuid=${this.$store.state.profile.uuid}`,
                `plataforma~eq=${PLATAFORMA}`,
                `tipo~eq=${TIPOS_SERVICIO.RECLAMACION}`,
              ],
              page: 0,
              size: -1,
              sort: [],
            },
          },
          fetchPolicy: "no-cache",
        })
        .then((response) => {
          const drafts = response.data.listaBorradores;

          this.displayDraftWarningModal =
            drafts &&
            drafts.totalElements > 0 &&
            !this.$route.params.draftId &&
            this.stepNum === 1;
        });
    },
    updateDireccionAcreedor() {
      const ctiAddress = this.$refs.datosAcreedor.updateAddress();
      this.currentDraft.datos.datosAcreedor.provincia = ctiAddress.provincia;
      this.currentDraft.datos.datosAcreedor.localidad = ctiAddress.localidad;
      this.currentDraft.datos.datosAcreedor.codigoPostal =
        ctiAddress.codigoPostal;
      this.currentDraft.datos.datosAcreedor.tipoVia = ctiAddress.tipoDireccion;
      this.currentDraft.datos.datosAcreedor.direccion = ctiAddress.direccion;
      this.currentDraft.datos.datosAcreedor.pais = "ES";
    },
    updateDireccionDeudor() {
      const ctiAddress = this.$refs.datosDeudor.updateAddress();
      this.currentDraft.datos.datosDeudor.provincia = ctiAddress.direccion;
      this.currentDraft.datos.datosDeudor.localidad = ctiAddress.localidad;
      this.currentDraft.datos.datosDeudor.codigoPostal = ctiAddress.codigoPostal;
      this.currentDraft.datos.datosDeudor.tipoVia = ctiAddress.tipoDireccion;
      this.currentDraft.datos.datosDeudor.direccion = ctiAddress.direccion;
      this.currentDraft.datos.datosDeudor.pais = "ES";
    },
  },
  created() {
    this.setCurrentStep();
    this.setProductCodeOrElseError();
    this.searchCurrentDraft();
  },
  mounted() {
    this.checkPreviousDrafts();
  },
};
</script>

<style lang="scss" scoped>
.verticalPadding {
  padding-top: 20px;
  padding-bottom: 20px;
}

.bigBlueButton {
  margin-bottom: 40px;
  margin-top: 40px;
}

.openTopWhitePanel {
  background-color: white;
  padding: 10px 7% 20px 7%;
  margin-bottom: 20px;
  margin-top: -2.5cm;
  border-left: 1px solid #d0e1f2;
  border-right: 1px solid #d0e1f2;
  border-bottom: 1px solid #d0e1f2;
}

.marginTop {
  margin-top: 2em;
}
</style>
